module.exports = require("@swa-ui/dotcom/src/DotcomHeader/DotcomHeaderLoading/DotcomHeaderLoading.module.scss");